import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

import Login from "pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

//404
import Pages404 from "pages/error/pages-404"
import Clients from "pages/Client"
import Testimonials from "pages/Testimonial"
import Lead from "pages/Lead/index"
import VehicleDetail from "pages/Vehicle/SingleView"
import Vehicles from "pages/Vehicle"
import Create from "pages/Vehicle/Crud/Update/Create"
import UpdateVehicles from "pages/Vehicle/Crud/Update/Update"
import LeadDetail from "pages/Lead/SingleView/index"
import InvestmentLeadDetail from "pages/InvestmentLeads/SingleView/index"
import ClientDetails from "pages/Client/SingleView"
import LeadFormPage from "pages/Lead/Create-update"
import LeadHistory from "pages/Lead-History"
import LeadNotes from "pages/Lead-Notes"
import Sales from "pages/Sale"
import UserPasswordPage from "pages/Authentication/userPassword"
import Members from "pages/Members"
import Users from "pages/AllUsers"
import ResetPasswordPage from "pages/Authentication/resetPassword "
import Category from "pages/category"
import Categories from "pages/Categories"
import CreateCategories from "pages/Categories/Crud/Create"
import UpdateCategories from "pages/Categories/Crud/Update"
import FollowUp from "pages/followUp"
import MatchingList from "pages/matchingList"
import MatchingListDetails from "pages/matchingList/SingleView"
import Privacy from "pages/Privacy"
import Inspection from "pages/Inspection"
import CreateInspectionDocs from "pages/Inspection/Crud/Create"
import UpdateInspectionDocs from "pages/Inspection/Crud/Update"
import InspectionBooking from "pages/InspectionBooking"
import CreateInspectionBooking from "pages/InspectionBooking/Crud/Create"
import UpdateInspectionBooking from "pages/InspectionBooking/Crud/Update"
import InspectionBookingDetails from "pages/InspectionBooking/singleView"
import ChallanList from "pages/Challan/Index"
import InspectionDocumentDetail from "pages/Inspection/SingleView/index"
import InspectionDocumentDetailsPDF from "pages/Inspection/SingleView/inspectionDetails"
import YoutubeVideos from "pages/Youtube"
import YoutubeShortVideos from "pages/YoutubeShort"
import CarDelivery from "pages/CarDelivery"
import Showrooms from "pages/Showroom"
import Banners from "pages/Banner"
import Branches from "pages/Branches"
import InvestmentLeads from "pages/InvestmentLeads"

const commonRoute = [
  { path: "/dashboard", component: Dashboard },

  { path: "/logout", component: Logout },

  {
    path: "/",
    exact: true,
    component: function dashboard() {
      return <Redirect to="/dashboard" />
    },
  },
  // followUp
  { path: "/followUp/all", component: FollowUp },
  { path: "/client/details/:id", component: ClientDetails },
]

const leadList = [
  // lead
  { path: "/lead/all", component: Lead },
  { path: "/lead/sales", component: Lead },
  { path: "/lead/purchase", component: Lead },
  { path: "/lead-details/:id", component: LeadDetail },
  { path: "/lead/create/new", component: LeadFormPage },
  { path: "/lead/update/:id", component: LeadFormPage },
]

const clientList = [
  // Client
  { path: "/client/all", component: Clients },
  { path: "/client/details/:id", component: ClientDetails },
]

const siteSettingsList = [
  { path: "/testimonial/all", component: Testimonials },
  { path: "/youtube-video/all", component: YoutubeVideos },
  { path: "/youtube-short-video/all", component: YoutubeShortVideos },
  { path: "/car-delivery/all", component: CarDelivery },
  { path: "/showroom/all", component: Showrooms },
  { path: "/banner/all", component: Banners },
]


const matchingLists = [
  // followUp
  { path: "/matching-list/all", component: MatchingList },
  { path: "/matching-list/details/:id", component: MatchingListDetails },
]

const vehicleList = [
  // vehicles
  { path: "/vehicle/all", component: Vehicles },
  { path: "/vehicle/details/:id", component: VehicleDetail },
  { path: "/vehicle/create", component: Create },
  { path: "/vehicle/update/:id", component: UpdateVehicles },
]

// inspection
const inspectionList = [
  { path: "/inspection/all", component: Inspection },
  { path: "/inspection/details/:id", component: InspectionDocumentDetail },
  { path: "/inspection/create", component: CreateInspectionDocs },
  { path: "/inspection/update/:id", component: UpdateInspectionDocs },
  { path: "/inspection/download", component: InspectionDocumentDetailsPDF },

  { path: "/inspection-booking/all", component: InspectionBooking },
  {
    path: "/inspection-booking/details/:id",
    component: InspectionBookingDetails,
  },
  { path: "/inspection-booking/create", component: CreateInspectionBooking },
  {
    path: "/inspection-booking/update/:id",
    component: UpdateInspectionBooking,
  },
]

// challan list
const challanList = [{ path: "/challan-list/all", component: ChallanList }]

// branch list
const branchList = [{ path: "/branch/all", component: Branches }]

// sales list
const salesList = [{ path: "/sale/all", component: Sales }]

// specification list
const specificationList = [
  { path: "/categories", component: Categories },
  { path: "/categories/create", component: CreateCategories },
  { path: "/categories/update/:id", component: UpdateCategories },
  // // models
  { path: "/category", component: Category },
]

// user list
const userList = [
  { path: "/member/all", component: Members }, // staff
  { path: "/user/all", component: Users },
  { path: "/profile", component: UserProfile },
]

const extraLeadList = [
  { path: "/lead/lead-history/all", component: LeadHistory },
  { path: "/lead/lead-notes/all", component: LeadNotes },
]

const hqStaffList = [{ path: "/hq-staff/all", component: Members }]

// investment lead list
const investmentLeadList = [
  { path: "/investment/leads/all", component: InvestmentLeads },
  { path: "/investment-lead-details/:id", component: InvestmentLeadDetail },
]
// user based routes

const headQuartersRoutes = [
  // super admin
  ...commonRoute,
  ...branchList,
  ...leadList,
  ...salesList,
  ...inspectionList,
  ...vehicleList,
  ...specificationList,
  ...clientList,
  ...userList,
  ...extraLeadList,
  ...hqStaffList,
  ...challanList,
  ...siteSettingsList,
  ...investmentLeadList,
]

const branchAdminRoutes = [
  // admin routes
  ...commonRoute,
  ...leadList,
  ...matchingLists,
  ...salesList,
  ...vehicleList,
  ...specificationList,
  ...clientList,
  ...userList,
  ...challanList,
  ...extraLeadList,
  ...hqStaffList,
]

const inspectionUserRoutes = [...commonRoute, ...inspectionList]

const managingDirectorRoutes = [
  ...commonRoute,
  ...leadList,
  ...vehicleList,
  ...clientList,
  ...salesList,
  ...userList,
]

const generalManagerRoutes = managingDirectorRoutes

const enquiryManagerRoutes = [
  ...commonRoute,
  ...clientList,
  ...leadList,
  { path: "/vehicle/all", component: Vehicles },
]

const enquiryAnalystRoutes = [
  ...commonRoute,
  ...leadList,

  // vehicles
  { path: "/vehicle/all", component: Vehicles },
  { path: "/vehicle/details/:id", component: VehicleDetail },
]

const salesExecutiveRoutes = [
  ...commonRoute,
  ...leadList,
  ...vehicleList,
  ...clientList,
  ...salesList,
]

const salesManagerRoutes = [
  ...commonRoute,
  ...leadList,
  ...vehicleList,
  ...salesList,

  { path: "/client/all", component: Clients },
]

const branchManagerRoutes = [
  ...commonRoute,
  ...leadList,
  ...vehicleList,
]

const purchaseManagerRoutes = [...commonRoute, ...vehicleList, ...leadList]
const businessDevelopmentOfficerRoutes = [...commonRoute, ...investmentLeadList]
const teamMemberRoutes = [...commonRoute]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/privacy", component: Privacy },
  { path: "/password/initialize/:id", component: UserPasswordPage },
  { path: "/password/reset/:id", component: ResetPasswordPage },
  { path: "/register", component: Register },
  { path: "/404", component: Pages404 },
]

export {
  publicRoutes,
  branchAdminRoutes,
  commonRoute,
  managingDirectorRoutes,
  salesExecutiveRoutes,
  salesManagerRoutes,
  enquiryAnalystRoutes,
  enquiryManagerRoutes,
  generalManagerRoutes,
  branchManagerRoutes,
  purchaseManagerRoutes,
  inspectionUserRoutes,
  headQuartersRoutes,
  businessDevelopmentOfficerRoutes,
  teamMemberRoutes,
}
